
import "./App.css";

import React, { Suspense } from "react";
import Loader from "./components/Loader";
import { BrowserRouter, Route, Routes } from "react-router-dom";
const StartMeet = React.lazy(() => import("./components/StartMeet"));
const Meeting = React.lazy(() => import("./components/Meeting"));
function App() {
  return (
    <Suspense fallback={<Loader />}>
      <BrowserRouter>
        <Routes >
          <Route path="/config" element={<StartMeet />} />
          <Route path="/meeting" element={<Meeting />} />
          <Route path="*" element={<StartMeet />} >
          </Route>
        </Routes>
      </BrowserRouter>
    </Suspense>
  );
}

export default App;
